import { FC } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useCurrentProjectId } from '@adsk/alloy-provider';
import { LocationProvider } from '@adsk/acc-locations-components';
import FeatureFlagsProvider from './FeatureFlagsProvider';
import LocalizationProvider from './LocalizationProvider';
import { OxygenProvider } from './OxygenProvider';
import { RFIsUsersProvider } from './RFIsUsersProvider';
import { DEFAULT_FEATURE_FLAGS_VALUES } from '../constants';

const Providers: FC = ({ children }) => {
  const queryClient = new QueryClient();
  const projectId = useCurrentProjectId();

  return (
    <QueryClientProvider client={queryClient}>
      <RFIsUsersProvider>
        <OxygenProvider>
          <LocalizationProvider>
            <LocationProvider projectId={projectId}>{children}</LocationProvider>
          </LocalizationProvider>
        </OxygenProvider>
      </RFIsUsersProvider>
    </QueryClientProvider>
  );
};

const RfisProvider: FC = ({ children }) => (
  <FeatureFlagsProvider defaultFeatureFlagsValues={DEFAULT_FEATURE_FLAGS_VALUES}>
    <Providers>{children}</Providers>
  </FeatureFlagsProvider>
);

RfisProvider.displayName = 'RfisProvider';

export default RfisProvider;
